<mat-card class="mb-4">
    <mat-card-header>
        <mat-card-title>
            {{ title }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="filters-container">
            <form [formGroup]="filterForm" class="search-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="filter()">
                <mat-grid-list cols="12" rowHeight="80px" gutterSize="10px">
                    <mat-grid-tile colspan="3" rowspan="1"></mat-grid-tile>
                    <mat-grid-tile colspan="1" rowspan="1">
                        <mat-form-field class="input-field">
                            <mat-label>Priorit&auml;t</mat-label>
                            <mat-select formControlName="priority">
                                <mat-option color="primary" *ngFor="let option of priorityOptions" [value]="option.value"> {{ option.name }} </mat-option>
                            </mat-select>   
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="3" rowspan="1">
                        <mat-form-field class="input-field">
                            <input matInput formControlName="firmenname" placeholder="Name der Firma">
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2" rowspan="1">
                        <mat-form-field class="input-field">
                            <input matInput formControlName="nlCode" placeholder="NlCode">
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="3" rowspan="1"></mat-grid-tile>
                </mat-grid-list>

                <mat-grid-list cols="12" rowHeight="80px" gutterSize="10px">
                    <mat-grid-tile colspan="2" rowspan="1"></mat-grid-tile>
                    <mat-grid-tile colspan="1" rowspan="1">
                        <mat-form-field class="input-field">
                            <mat-label>Datum filtern</mat-label>
                            <mat-select formControlName="dateOption">
                                <mat-option color="primary" *ngFor="let option of dateOptions" [value]="option"> {{ option }} </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2" rowspan="1">
                        <mat-form-field class="input-field">
                            <mat-label>Datum</mat-label>
                            <input matInput formControlName="date" [matDatepicker]="picker">
                            <mat-hint>TT.MM.YYYY</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker [startAt]="startDate"></mat-datepicker>
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2" rowspan="1">
                        <mat-form-field class="input-field">
                            <input matInput formControlName="salesforceId" placeholder="Salesforce-Account-ID">
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="3" rowspan="1">
                        <mat-form-field class="input-field">
                            <input matInput formControlName="id" placeholder="Aufgabe-ID">
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2" rowspan="1"></mat-grid-tile>
                </mat-grid-list>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions class="filter-buttons justify-content-center">
        <button class="btn bg-gradient-secondary btn-flat mr-4" (click)="removeFilters()">
            Zur&uuml;cksetzen <i class="fas fa-times"></i>
        </button>
        <button class="btn bg-gradient-primary btn-flat pl-4 pr-4" (click)="filter()">
            Filtern <i class="fas fa-search"></i>
        </button>
    </mat-card-actions>
</mat-card>

<mat-card class="mb-4">
    <mat-card-content>
        <p class="small text-center" *ngIf="resultListLength >= pageSize">Es werden nur die ersten {{pageSize}} Ergebnisse angezeigt.</p>
        <table mat-table [dataSource]="resultDataSource" class="mat-elevation-z1"
            [attr.colspan]="displayedColumns.length + 1" matSort (matSortChange)="sortData(resultDataSource)">

            <ng-container matColumnDef="realDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    DATUM
                </th>
                <td mat-cell *matCellDef="let element">{{element.realDate|date:'dd.MM.yyyy'}}</td>
            </ng-container>

            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                    {{column.label.toUpperCase()}}
                </th>
                <td mat-cell *matCellDef="let element">{{element[column.name]}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [class.element-row]="row.length" (click)="goToAufgabe(row)"></tr>
        </table>
        <mat-paginator #paginator
                       [hidden]="resultDataSource.length <= 10"
                       [length]="resultDataSource.length"
                       [showFirstLastButtons]="true"
                       [pageSize]="10"
                       [pageSizeOptions]="[10, 25, 50]">
        </mat-paginator>

    </mat-card-content>
</mat-card>